import { ShipmentCreationTemplateTypes } from "@shared/enums/shipment-creation-template-types.enum";

const ComponentName = 'sidebar';

export const SidebarIds = {
    CreateShipmentMenu: `${ComponentName}__create-shipment-menu`,
    CreateShipmentBasic: `${ComponentName}__create-shipment-${ShipmentCreationTemplateTypes.Basic}`,
    ShipmentsMenu: `${ComponentName}__shipments-menu`,
    BackhaulTab: `${ComponentName}__backhaul-tab`,
    CustomersMenu: `${ComponentName}__customers-menu`,
    CustomersTab: `${ComponentName}__customers-tab`,
    InvoicesMenu: `${ComponentName}__invoices-menu`,
    FleetInvoicesTab: `${ComponentName}__fleet-invoices-tab`,
} as const;
